import React, {useContext} from "react";
import {ModalContext} from "../../Modal/ModalProvider";
import {fetchRootlineEvents, startRootlineEventsDownload} from "../../services";
import AbstractItemsTableWithLoader from "../../Tables/AbstractItemsTableWithLoader";

const RootlineTable = () => {
    const {showModal} = useContext(ModalContext);

    const tableColumns = {
        eventTime: {
            name: 'Event Time',
            sort: true,
            style: {
                width: '185px',
            },
        },
        paymentId: 'Payment Id',
        accountId: {
            name: 'Account Id',
            sort: true
        },
        name: {
            name: 'Account Name',
            sort: true
        },
        amount: 'Amount',
        pomFee: 'POM Fee',
        payitFee: 'PayIt Fee',
        description: 'Description'
    };

    const namedSearchParameters = {
        eventTime: {
            type: 'date',
            name: 'Event Time',
            operators: ['eq', 'lt', 'gt', 'between'],
        },
        paymentId: {
            type: 'text',
            name: 'Payment Id',
            operators: ['eq'],
        },
        accountId: {
            type: 'text',
            name: 'Account Id',
            operators: ['eq'],
        },
        name: {
            type: 'text',
            name: 'Account Name',
            operators: ['eq', 'contains'],
        },
        amount: {
            type: 'text',
            name: 'Amount',
            operators: ['eq', 'lt', 'gt'],
        },
        pomFee: {
            type: 'text',
            name: 'POM Fee',
            operators: ['eq', 'lt', 'gt'],
        },
        payitFee: {
            type: 'text',
            name: 'PayIt Fee',
            operators: ['eq', 'lt', 'gt'],
        },
        description: {
            type: 'text',
            name: 'Description',
            operators: ['eq', 'contains'],
        },
    };

    return <AbstractItemsTableWithLoader
        tableColumns={tableColumns}
        namedSearchParameters={namedSearchParameters}
        fetchFunction={fetchRootlineEvents}
        autoWidthColumns={['eventTime', 'paymentId', 'accountId', 'amount', 'pomFee', 'payitFee', 'description']}
        downloadModalFunc={startRootlineEventsDownload}
        downloadModalDomainObjectName="rootline events"
        showModal={showModal}
    />;
};

export default RootlineTable;
